import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IPrice } from '@shared/jp/data/products';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
  selector: 'app-toggle-cards-item[name][description][price][value]',
  templateUrl: './toggle-cards-item.component.html',
  styleUrls: ['./toggle-cards-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleCardsItemComponent {
  @Input() name!: string;

  @Input() description!: string;

  @Input() price!: IPrice;

  @Input() value!: any;

  @Input() disabled = false;

  @Input() discount?: string | undefined | null;

  public active$ = new BehaviorSubject(false);

  // eslint-disable-next-line @angular-eslint/no-output-native
  click$ = new Subject<void>();

  // constructor() {}

  onClick() {
    this.click$.next();
  }
}
